export const typeSerializer = type => `Type(${type})`;
export const seriesIdSerializer = id => `Series(${id})`;
export const dataIndexSerializer = dataIndex => dataIndex === undefined ? '' : `Index(${dataIndex})`;
export const identifierSerializerSeriesIdDataIndex = identifier => {
  return `${typeSerializer(identifier.type)}${seriesIdSerializer(identifier.seriesId)}${dataIndexSerializer(identifier.dataIndex)}`;
};